<template>
  <div class="current">
    <div class="top-banner"></div>
    <!-- <div class="description">
      <div class="d_title">在这里，你的愿望统统都可以实现！</div> 
      <div class='show-icon'>
            <div class="icon icon1">
            同步发布至主流音乐平台
            </div>
            <div class="icon icon2">
            明星制作人助力发行专辑
            </div>
            <div class="icon icon3">
            拥有自己专属的音乐视频
            </div>
            <div class="icon icon4">
            报名大师课Get创作技能
            </div>
      </div>
    </div> -->
    <div class="top-cantiner">
      <div class="header-bar">
        <div class="list-title">
          <router-link :class="{ active: type == 'intro' }" to="/current/intro"
            >活动介绍</router-link
          >
          <!-- <router-link to="/current/calender">活动日程</router-link> -->
          <!-- <router-link to="/current/rule">评选规则</router-link> -->
          <router-link to="/current/know">报名须知</router-link>
          <!-- <router-link to="/current/lesson">创作大师课</router-link> -->
        </div>
      </div>
      <div class="text t-mid" v-if="type == 'intro'">
        <!-- <p>原创，是这个时代最有价值的表达。<strong >
        <img class='w b' src='../assets/icons/c_icon1/1.png'><span></span><img class='h' src='../assets/icons/c_icon1/3.png'></strong></p>
      为了鼓励更多优质的原创音乐涌现，<br>
      为创作者的作品提供更好的平台和曝光，<br>
      牛班特此发布【牛班音乐合伙人计划】，<br/>
      赶快将你的原创歌曲投递过来吧！<br/> -->
        <div class="acctiveIntroduce">
          <div class="top">
            <!-- <span>一种声音，就是一个故事，一段人生。</span>
              <span>为了给拥有好声线的你更多优质的表现机会，牛班联手华声时代，发出甄选</span>
              <span>招募令，让好声线能够与好作品相遇，诞生更多精彩的音乐作品。只要你满</span>
              <span>足下列六种声线之一，那么不要犹豫，立刻选择一首相应的歌曲进行翻唱，</span><br>
              <span>投递给我们吧！</span><br>
              <span>即刻参与，便有机会赢得唱片签约！让你被更多人所听到！</span> -->
          </div>
          <div class="bottom-btn">
			  <a href="https://nfp.newband.com/act/By%20Your%20Side%20v18.mp3?attname=" rel="noopener" target="_blank" data-sensors-click="true" name="sensors-resourceV2-download" class="btn" @click="download">原唱DEMO下载</a>
			  <a href="https://nfp.newband.com/act/By%20Your%20Side%20v18%20Instrumental.mp3?attname=" rel="noopener" target="_blank" data-sensors-click="true" name="sensors-resourceV2-download" class="btn" @click="download">伴奏下载</a>
			  <a href="https://nfp.newband.com/act/%E6%AD%8C%E8%AF%8D.rtf" class="btn" @click="download">歌词下载</a>
		  </div>
        </div>
        <br />
        <!-- <div class="RecruitmentTarget">招募对象：牛班全体学员</div> -->
        <!-- 更有机会<strong ><img class='w b' src='../assets/icons/c_icon1/2.png'><span>发行实体专辑和专属音乐视频。</span><img class='h' src='../assets/icons/c_icon1/4.png'></strong> -->
      </div>
      <div class="text" v-if="type == 'calender'"></div>
      <div class="text" v-if="type == 'rule'">
        1. 登录Songbank活动官网，上传个人原创作品。<br />
        2.参赛作品需围绕<i
          ><img class="h" src="../assets/icons/c_icon3/1.png" /><span
            >当期的两个主题</span
          ><img class="h" src="../assets/icons/c_icon3/2.png" /></i
        >进行创作。<br />
        3.
        所有合作音乐平台将合计后台播放数据，实时更新至Songbank榜单，搜索即可进入查看。<br />
        4. 比赛结合播放数据和专业评审团的意见，评出最终<i class="tweleve"
          >十二强</i
        >，歌曲将收入专辑发行并<i class="music1">拍摄</i
        ><i class="music2">专属</i><i class="music3">音乐视频</i>。<br />
        5.<i
          ><img class="w b" src="../assets/icons/c_icon3/0.png" /><span>
            奖项及版权分成等事宜，以上传者</span
          ></i
        ><i
          ><img class="w b" src="../assets/icons/c_icon3/00.png" /><span
            >实名信息资料为准，如作品由多人创作</span
          ></i
        >，则具体分成由上传者与其余创作者自行协商完成。
      </div>
      <div class="knowBg" v-if="type == 'know'">
        <div class="know"></div>
      </div>
      <div class="text" v-if="type == 'lesson'">
        我们针对当期主题为大家安排了有趣的大师课程，大师课<i class="topic"
          >每期玩转两个主题</i
        >，将有专业的作曲老师带你学习写歌，作词老师针对主题进行词作修改，经专业老师<i
          ><img class="w b" src="../assets/icons/c_icon2/2.png" />一</i
        >对<i><img class="w b" src="../assets/icons/c_icon2/3.png" />一</i
        >的辅导和修改后，最终你将迎来进入专业<i class="record">录音棚录制</i
        >自己原创作品的绝佳机会哦~<i
          ><img class="h" src="../assets/icons/c_icon2/6.png"
        /></i>
        <br /><br />
        价格：6000元／人／期，报名学员每完成并提交一首有效作品将获得奖学金<i
          class="mon"
          >500</i
        >元。
      </div>
      <!-- <router-link class='attend' to="/upload">我要参赛</router-link> -->
    </div>
    <div class="detail-cantiner">
      <!-- <div class="title"><img src='../assets/title.png'></div>
    <div class="search-bar">
        <div class="list-title">
          
          <span :class="{col:show=='last'}" @click="last()">最新</span>|
          <span :class="{col:show=='hot'}" @click='hot()'>最热</span>
         
        </div>
        <div class="swork">
          <input type="text" v-model="searchKey"  placeholder="通过搜索快速找到你喜欢的作品"/> <i @click="onSearch"/>
        </div>
        
      </div>
      <ul class="song-list">
        <li>
          <div class="song-cover">&nbsp;</div>
          <span>歌名</span>
          <span>演唱者</span>
          <span>作词</span>
          <span>作曲</span>
          <span>编曲</span>
          <span>校区</span>
          <span>上传者</span>
          
        </li>
        <li v-for="(item, index) in this.$store.state.current.list" :key="index" :class="$store.state.songInfo.curIndex === index && $store.state.songInfo.playing ? 'li-bg': 'li-no-bg'">
          <div class="song-cover" @click.stop="onPlaySong(index,item.wkid)">
            <img :src="item.wkcoverurl" />
            <i :class="$store.state.songInfo.curIndex === index && $store.state.songInfo.playing ? 'btn-pause': 'btn-play'"/>
          </div>  
          <div  @click.stop="onPlaySong(index,item.wkid)" class="song-info">
           <span class="wksongname" @click="onGoSong(index)">{{item.wksongname}}</span>
            <span>{{item.wksinger}}</span>
            <span>{{item.wkwriter}}</span>
            <span>{{item.wkcompositor}}</span>
            <span>{{item.wkmelody}}</span>
            <span>{{item.convert.userschool}}</span>
            <span @click="onGoPhome(index)"  class="subname">{{item.userfullname}}</span>
            
          </div>
        </li>
      </ul> -->
      <router-link class="attend_img" to="/upload"
        ><img src="../assets/current_attend1.png"
      /></router-link>
    </div>
  </div>
</template>

<script>
import { request } from "../utils";
// @ is an alias to /src
import HelloWorld from "@/components/HelloWorld.vue";
import Login from "@/components/Login.vue";
export default {
  name: "current",
  components: {
    Login
  },
  data() {
    return {
      searchKey: "",
      show: "last",
      type: "intro",
      songList: [],
    };
  },

  // destroyed() {
  //       window.onbeforeunload = null
  //     },
  //  beforRouteUpdat (to, from, next) {
  //    if(from.path==='/current'){
  //      next({name:'current'})
  //    }
  //    console.log(to,from,next)
  //    next()
  //  },
  methods: {
    download (e) {
      let { userInfo } = this.$store.state;
      if (!userInfo.islogin) {
        e.preventDefault();
        this.$modal.show('loginModal');
      }
    },
    handleScroll() {
      document.querySelector(".detail-cantiner a").classList =
        "attend_img router-link-active fixed";
      //      var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
      //     var offsetTop = document.querySelector('.detail-cantiner').offsetTop;
      //     // console.log(offsetTop,scrollTop)
      // if(scrollTop>=1650){//&&scrollTop<2500
      //   document.querySelector('.detail-cantiner a').classList='attend_img router-link-active fixed'

      // }
      // else{
      //   document.querySelector('.detail-cantiner a').classList='attend_img router-link-active'
      // }
    },
    onSearch() {
      if (this.searchKey)
        this.$router.push({ name: "search", params: { key: this.searchKey } });
    },

    onGoSong(index) {
      // this.$store.commit('toggleSong', index)
      this.$router.push("/song");
    },
    onGoPhome(index) {
      this.$router.push({ name: "phome", params: { key: index } });
    },

    hot() {
      let { current } = this.$store.state;

      request("/guest/works/search", { sortField: "hot" }).then((res) => {
        if (res.success) {
          this.$store.commit("setCurrentList", res.data.data);
          //  console.log(this.$store.state.songInfo.curIndex)
          // console.log(current.list)
          this.$store.commit("setSongList", current.list);
        }
      });
      this.show = "hot";
    },
    last() {
      let { current } = this.$store.state;
      this.show = "last";
      request("/guest/works/search", { sortField: "wkaddtime" }).then((res) => {
        if (res.success) {
          this.$store.commit("setCurrentList", res.data.data);
          this.$store.commit("setSongList", current.list);
        }
      });
    },
    onPlaySong(index, wkid) {
      if (!this.$store.state.songInfo.playing) {
        request("/guest/works/play", { wkid: wkid }).then((res) => {
          if (res.success) {
            console.log(123);
          }
        });
      }

      this.$store.commit("toggleSong", index);

      // console.log(this.$store.state.current.list)
    },
    changerouter() {
      var type = this.$route.params.type;
      this.type = type ? type : "intro";
    },
  },
  watch: {
    $route: "changerouter",
  },
  created: function () {
    let { current } = this.$store.state;
    if (current.list.length === 0)
      request("/guest/works/search", {}).then((res) => {
        if (res.success) {
          this.$store.commit("setCurrentList", res.data.data);

          this.$store.commit("setSongList", current.list);
        }
      });
    else this.$store.commit("setSongList", current.list);
  },

  mounted() {
    window.addEventListener("scroll", this.handleScroll);
  },
  destroyed() {
    window.removeEventListener("scroll", this.handleScroll);
  },
};
</script>
<style lang="less" scoped>
* {
  box-sizing: border-box;
}
.fixed {
  position: fixed !important;
}
.li-bg {
  padding: 10px;
  margin-bottom: 20px !important;
  span {
    font-weight: normal;
    color: #eb6fa6 !important;
  }
}
.RecruitmentTarget {
  color: rgb(231, 144, 221);
  font-size: 20px;
  width: 1040px;
  margin: 1px auto;
}
.acctiveIntroduce {
  width: 1040px;
  margin: auto;
  margin-top: 54px;
  .top {
    width: 866px;
    padding-top: 111px;
    padding-left: 35px;
    height: 693px;
    background: url("../assets/theme.png") no-repeat;
    background-size: 100%;
    span {
      display: inline-block;
      color: rgb(231, 144, 221);
      line-height: 36px;
      // padding-top: 7px;
      background: #000;
      padding-left: 12px;
      padding-right: 20px;
      // padding-bottom: 11px;
      font-size: 20px;
      margin-bottom: 6px;
    }
    span:nth-child(1) {
      font-weight: 700;
      font-size: 24px;
      margin-bottom: 12px;
    }
  }
  .bottom-btn {
    display: flex;
	justify-content: space-between;
	margin-top: 80px;
	padding-right: 170px;
	padding-left: 50px;
	.btn {
		width: 176px;
		height: 48px;
		background-color: #cc19ff;
		box-shadow: 0 0 50px #cc19ff;
		text-align: center;
		color: #000;
		border-radius: 8px;
	}
  }
}
.knowBg {
  height: 725px;
  padding: 0.1px;
  background-image: url("../assets/knowBg.png");
  background-size: 100%;
}
.know {
  width: 908px;
  height: 369px;
  margin: auto;
  margin-bottom: 200px;
  margin-top: 30px;
  background: url("../assets/know2.png") no-repeat;
  background-size: 100%;
  div {
    padding-left: 56px;
    color: rgb(231, 144, 221);
    font-size: 20px;
    margin-bottom: 12px;
  }
}
.li-no-bg {
  padding: 10px;
  margin-bottom: 20px !important;
  span {
    color: white !important;
  }
}
@media screen and (min-width: 1440px) {
  .detail-cantiner {
    background: url("../assets/c_nbg1.png") center no-repeat;
    background-size: 100% auto;
  }
}
@media screen and (max-width: 1440px) {
  .detail-cantiner {
    background: url("../assets/c_nbg.png") top no-repeat;
    background-size: 100% auto;
  }
}
.current {
  background-color: #181818;
}
.detail-cantiner {
  max-width: 1440px;
  margin: 0 auto;
  a {
    position: absolute;
    top: 50%;
    right: 1%;
    height: 56px;
    border-radius: 0 30px 30px 0px;
    background-color: none;
  }
  a:hover {
    box-shadow: 0 0 50px #f987bd;
  }
  // background-size:100% 100%;
  position: relative;
  ul.song-list {
    padding: 0px 0 80px;

    margin: 0 auto;
    width: 80%;
    text-align: left;
    color: white;
    li {
      font-weight: normal;
      border-radius: 5px;
      white-space: nowrap;
      &:first-child {
        background: none;
        color: grey;
        margin-bottom: 0;
        height: 45px;
        padding: 0 10px;
        &:hover {
          cursor: inherit;
          background: none;
        }
      }
      .song-cover {
        width: 90px;
      }
      span {
        flex: 1;
      }
      width: 100%;
      display: flex;
      justify-content: space-between;

      div:not(.song-cover) {
        width: calc(100% - 90px);
        span {
          width: 14.5%;
          box-sizing: border-box;
          overflow-x: hidden;
          color: white;
        }
      }
    }
  }
  //padding-top:20px;
  background-color: #181818;
  color: white;
  .title {
    margin: 30px auto 0;
  }
  .search-bar {
    padding: 80px 0;
    display: flex;
    justify-content: space-between;
    margin: 0 auto;
    font-size: 18px;
    width: 80%;
    text-align: left;
    .swork {
      position: relative;
      width: 650px;
      // right:0;
      // border-bottom: 1px solid  #FFFFFF;
      input {
        position: absolute;
        left: 0;
        padding-bottom: 5px;
        bottom: 0px;
        width: 100%;
        font-size: 18px;
        line-height: 26px;
        border: none;
        background: none;
        color: white;
        outline: none;
        border-bottom: 1px solid #333;
        &:focus {
          border-bottom: 1px solid #eb6fa6;
          & + i {
            background: url("../assets/icons/search-active_c.png") center
              no-repeat;
          }
        }
      }
      i {
        display: inline-block;
        position: absolute;
        bottom: 5px;
        right: 0;
        width: 25px;
        height: 25px;
        background: url("../assets/icons/search-black.png") center no-repeat;
        cursor: pointer;
        &:hover {
          background: url("../assets/icons/search-active_c.png") center
            no-repeat;
        }
      }
    }
    span {
      font-weight: normal;
      padding: 10px;
      &:hover {
        cursor: pointer;
      }
      &.col {
        color: #eb6fa6;
      }
    }
    input {
      position: absolute;
      left: 0;
      bottom: 5px;
      width: 410px;
      font-size: 18px;
      line-height: 26px;
      border: none;
      background: none;
      outline: none;
    }
  }
}
.top-banner {
  position: relative;
  overflow-y: hidden;
  min-width: 1280px;
  min-height: 750px;
  background: url("../assets/current-banner2.png") no-repeat;
  background-size: cover;
  // height: 760px;
  // .col1,.col2{
  //   position: absolute;
  //   width: 50%;
  //   height: 100%;
  //   top:0;
  // }
  // .col1{
  //   background-color: #E494DB;
  //   z-index: 0;
  // }
  // .col2{
  //   background-color: #E494DB;
  //   left:50%;
  //   z-index: 0;
  // }
  img {
    min-width: 1440px;
    position: relative;
    // z-index: 1;
    height: auto;
  }
}
.description {
  .d_title {
    font-weight: normal;
    font-size: 24px;
  }
  color: white;
  text-align: center;
  padding: 90px 0;
  height: 400px;
  width: 100%;
  line-height: 110px;
  background: #000000;
  background: -moz-linear-gradient(left center, #1c1966 100%, #f3a3c7 100%);
  background: -webkit-gradient(
    linear,
    left top,
    right bottom,
    from(#f3a3c7),
    to(#1c1966)
  );
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#1C1966', endColorstr='#F3A3C7',GradientType=1 );
  .show-icon {
    overflow: hidden;
    display: flex;
    justify-content: space-around;
    margin: 0 auto;
    max-width: 1440px;
    width: 80%;
    .icon {
      // width:130px;
      height: 150px;
      font-size: 14px;
      font-weight: normal;
      line-height: 300px;
      float: left;
      padding: 0 10px 20px;
    }
    .icon1 {
      background: url("../assets/icons/corpo.png") center no-repeat;
      background-size: 75px 75px;
    }
    .icon2 {
      background: url("../assets/icons/song.png") center no-repeat;
      background-size: 75px 75px;
    }
    .icon3 {
      background: url("../assets/icons/video.png") center no-repeat;
      background-size: 75px 75px;
    }
    .icon4 {
      background: url("../assets/icons/skill.png") center no-repeat;
      background-size: 75px 75px;
    }
  }
}
@media screen and (max-width: 1440px) {
  .top-cantiner {
    //background:url('../assets/c_bg.png') right no-repeat;
    //background-size:auto 100%;
    background-color: #553a9c;
  }
}
@media screen and (min-width: 1440px) {
  .top-cantiner {
    //background:url('../assets/c_bg.png') right no-repeat;
    //background-size:100% auto;
    background-color: #553a9c;
  }
}
.top-cantiner {
  //height:600px;
  position: relative;
  strong,
  i {
    font-weight: normal;
  }
  .text {
    font-size: 16px;
    font-weight: normal;
    background-image: url("../assets/bigBg.png");
    background-size: 100%;
    .topic {
      display: inline-block;
      background: url("../assets/icons/c_icon2/1.png") center no-repeat;
    }
    .tweleve {
      // height:100px;
      display: inline-block;
      background: url("../assets/icons/c_icon3/3.png") center no-repeat;
    }
    .music1 {
      display: inline-block;
      background: url("../assets/icons/c_icon3/4.png") center no-repeat;
    }
    .music2 {
      display: inline-block;
      background: url("../assets/icons/c_icon3/5.png") center no-repeat;
    }
    .music3 {
      display: inline-block;
      background: url("../assets/icons/c_icon3/6.png") center no-repeat;
    }
    .ti {
      display: inline-block;
      background: url("../assets/icons/c_icon4/7.png") center no-repeat;
    }
    .ti1 {
      display: inline-block;
      background: url("../assets/icons/c_icon4/6.png") center no-repeat;
    }
    .not1 {
      display: inline-block;
      background: url("../assets/icons/c_icon4/3.png") center no-repeat;
    }
    .not2 {
      display: inline-block;
      background: url("../assets/icons/c_icon4/4.png") center no-repeat;
    }
    .mon {
      display: inline-block;
      background: url("../assets/icons/c_icon2/7.png") center no-repeat;
    }
    .record {
      display: inline-block;
      background: url("../assets/icons/c_icon2/5.png") center no-repeat;
    }
    strong,
    i {
      position: relative;
      span {
        position: relative;
        z-index: 10;
      }
      img {
        position: absolute;
        bottom: 0;
        height: 100%;
      }
      img.h-s {
        height: 80%;
      }
      img.h {
        position: absolute;
        bottom: 0;
        height: 150%;
      }

      img.w {
        position: absolute;
        bottom: 0;
        width: 100%;
      }
      .b {
        bottom: -10px !important;
      }
    }
    // .c1_t1{
    //   background:url('../assets/icons/c_icon1/1.png') bottom no-repeat;
    //   background-size:100% auto;
    // }
    // .c1_t2{
    //   background:url('../assets/icons/c_icon1/2.png') bottom no-repeat
    // }
    color: white;
    //width:685px;
    width: 100%;

    margin: 0 auto;
    padding: 20px 0;
    text-align: left;
    line-height: 40px;
  }
  .t-mid {
    //text-align:center;
    height: 1040px;
    background-image: url("../assets/bigBg.png");
    background-size: 100%;
  }

  width: 100%;
  min-width: 1440px !important;
  box-sizing: border-box;
  //background-color: #000;
  background-color: #553a9c;
  overflow: hidden;
  .header-bar {
    width: 100%;
    border-bottom: 1px solid #7a7382;
    background-color: #000;
    // display: flex;

    .list-title {
      display: flex;
      justify-content: space-around;
      width: 80%;
      margin: 0 auto -1px;
      padding: 28px 0 0;
      a {
        flex: 0.09;
        font-size: 16px;
        font-weight: normal;
        color: #b3b3b3;
        letter-spacing: 0.95px;
        text-align: center;
        line-height: 56px;
        &.router-link-exact-active,
        &.active {
          border-bottom: white 3px solid;
          font-weight: bolder;
          color: white;
        }
      }
    }
  }
  a.attend {
    position: absolute;
    bottom: 40px;
    left: 0;
    right: 0;
    background: -webkit-gradient(
      linear,
      left top,
      right bottom,
      from(#f3a3c7),
      to(#1c1966)
    );
    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#1C1966', endColorstr='#F3A3C7', GradientType=1);
    width: 240px;
    line-height: 48px;
    display: block;
    margin: 0 auto;
    border-radius: 5px;
    color: white;
  }
}
.song-list {
  margin-top: 40px;
  width: calc(100% + 45px);
  text-align: left;
  li:hover .btn-play {
    background-size: 100%;
    background: url("../assets/icons/c_play.png") center no-repeat;
  }
  li {
    text-align: center;
    &:hover {
      cursor: pointer;
      background: -moz-linear-gradient(top center, #1c1966 100%, #f3a3c7 100%);
      background: -webkit-gradient(
        linear,
        right bottom,
        right top,
        from(#1c1966),
        to(#f3a3c7)
      );
      filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#1C1966', endColorstr='#F3A3C7',GradientType=1 );
    }
    background: -moz-linear-gradient(top center, #181818 100%, #070707 100%);
    filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#1C1966', endColorstr='#F3A3C7',GradientType=1 );
    background: -webkit-gradient(
      linear,
      left top,
      left bottom,
      from(#181818),
      to(#070707)
    );
    display: inline-block;
    margin-bottom: 66px;
    // width: 180px;
    margin-right: 45px;
    .song-cover {
      position: relative;
      width: 90px;
      height: 90px;
      img {
        width: 100%;
        height: 100%;
      }
      i {
        display: block;
        position: absolute;
        width: 76px;
        height: 80px;
        left: 0;
        top: 0;
        right: 0;
        bottom: 0;
        margin: auto;
        cursor: pointer;

        &.btn-pause {
          background-size: 100%;
          background: url("../assets/icons/c_stop.png") center no-repeat;
        }
      }
    }
    .song-info {
      margin-top: 8px;
      font-size: 16px;
      color: #000000;
      line-height: 22px;
      text-align: center;
      width: 100%;
      // display: flex;
      // justify-content: space-between;
      span {
        line-height: 82px;
        display: inline-block;
        text-align: left;
        padding: 0 40px;
        width: 100%;
        &:nth-child(3) {
          color: #b3b3b3;
        }
      }
      .subname:hover {
        color: #eb6fa6 !important;
      }
      .wksongname {
        color: #eb6fa6 !important;
      }
    }
  }
}

// .image-uploader {
//   width: 500px;
//   margin: 0 auto;
// }
// .audio-uploader {
//   width: 800px;
//   margin: 0 auto;
// }
</style>